(function () {
   const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
   
   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
     viewTransitionRenderBlocker?.remove();
   } else {
     const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());
     setTimeout(() => {
       viewTransitionRenderBlocker?.remove();
     }, RENDER_BLOCKER_TIMEOUT_MS);
   }

   const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

   window.addEventListener('pageswap', async (event) => {
     const { viewTransition } = /** @type {PageSwapEvent} */ (event);
     if (shouldSkipViewTransition(viewTransition)) {
       /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
       return;
     }

     // High-Performance INP Guard: Cancel calculation loop on instant secondary interactions
     ['pointerdown', 'keydown'].forEach((eventName) => {
       document.addEventListener(
         eventName,
         () => { viewTransition.skipTransition(); },
         { once: true }
       );
     });

     // Target custom image card triggers
     const transitionTriggered = document.querySelector('[data-view-transition-triggered="true"]');
     const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

     if (transitionType) {
       viewTransition.types.clear();
       viewTransition.types.add(transitionType);
       // Calculate explicit bounds to prevent image stretching across viewport changes
       const interactiveImage = transitionTriggered.querySelector('img');
       if (interactiveImage) {
         interactiveImage.style.viewTransitionName = 'active-pdp-hero';
       }
       sessionStorage.setItem('custom-transition-type', transitionType);
     } else {
       viewTransition.types.clear();
       viewTransition.types.add('page-navigation');
       sessionStorage.removeItem('custom-transition-type');
     }
   });

   window.addEventListener('pagereveal', async (event) => {
     const { viewTransition } = /** @type {PageRevealEvent} */ (event);
     if (shouldSkipViewTransition(viewTransition)) {
       /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
       return;
     }

     const customTransitionType = sessionStorage.getItem('custom-transition-type');
     if (customTransitionType) {
       viewTransition.types.clear();
       viewTransition.types.add(customTransitionType);
       
       // Match target container elements on the incoming PDP page layout
       const incomingHero = document.querySelector('.product-information__media img, .product-media__image');
       if (incomingHero) {
         incomingHero.style.viewTransitionName = 'active-pdp-hero';
       }

       await viewTransition.finished;
       viewTransition.types.clear();
       viewTransition.types.add('page-navigation');
       
       // Clean up styles to maintain consistent component isolation boundaries
       if (incomingHero) incomingHero.style.removeProperty('view-transition-name');

       idleCallback(() => {
         sessionStorage.removeItem('custom-transition-type');
         document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
           element.removeAttribute('data-view-transition-type');
           element.removeAttribute('data-view-transition-triggered');
         });
       });
     } else {
       viewTransition.types.clear();
       viewTransition.types.add('page-navigation');
     }
   });

   function shouldSkipViewTransition(viewTransition) {
     return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
   }

   function isLowPowerDevice() {
     return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
   }
 })();